module.exports = __webpack_public_path__ + "img/photo3.20fc1ffa.jpg";